<template>
    <div class="tableLine">
        <div class="contentLine">
            <div class="tableBoxTitleFirst">{{ data.operatingStepsName }}</div>
            <div class="tableBoxTitle">{{ data.operatingUserName }}</div>
            <div class="tableBoxTitle">{{ data.operatingPositionName }}</div>
            <div class="tableBoxTitle">
                <span class="statusBox1" :class="{ 'statusSuccess': data.approveResult && data.operatingSteps != 1, 'statusFail': !data.approveResult && data.operatingSteps != 1 }"></span>
                {{ data.operatingSteps == 1 ? '--' : (data.approveResult ? '通过' : '不通过') }}
            </div>
            <div class="tableBoxTitle">{{ data.createTime | filterA }}</div>
            <div class="tableBoxTitleLast">
                <span class="oper" @click="showFun">{{ !showDetails ? '显示详情' : '收起' }}</span>
            </div>
        </div>
        <div class="contentDetails" v-if="showDetails">
            <div class="detailsBox">
                <el-form label-position="right" inline label-width="80px" style="margin-top: -15px;">
                    <template v-if="data.operatingSteps == 1">
                        <div class="pageTitle">提交内容</div>
                        <div v-for="(item, index) in planList" :key="index">
                            <el-form-item v-if="item.type == 1 && item.value.length > 0" label="文字信息">
                                <div v-for="(itm,i) in item.value" :key="i">{{ itm.content }}</div>
                            </el-form-item>
                            <el-form-item v-if="item.type == 4 && item.value.length > 0" label="网盘地址">
                                <div v-for="(itm,i) in item.value" :key="i">{{ itm.content }}</div>
                            </el-form-item>
                            <el-form-item v-if="item.type == 3 && item.value.length > 0" label="相关附件">
                                <el-button type="primary" size="small" @click="downAll(data)" style="margin-bottom: 10px">批量下载</el-button>
                                <div class="viewItem" v-for="(itm,i) in item.value" :key="i">
                                    <div>{{ itm.contentName ? itm.contentName : itm.name }}</div>
                                    <em class="el-icon-view viewItemIcon" v-if="itm.contentType == 2" @click="previewImg(itm.content)"></em>
                                    <em class="el-icon-view viewItemIcon" v-if="itm.contentType != 6 && itm.contentType != 2" @click="seeView(itm.content)"></em>
                                    <em class="el-icon-download viewItemIcon"
                                        @click="downloadFile(itm.content, itm.contentName)"></em>
                                </div>
                            </el-form-item>
                        </div>
                    </template>
                    <template v-if="data.operatingSteps != 1">
                        <div class="pageTitle">审批内容</div>
                        <el-form-item label="审批结果" v-if="transData.approveResult || transData.checkResult > -1">
                            {{ transData.approveResult ? '通过' : (transData.checkResult == 1 ? '通过' : '不通过') }}
                        </el-form-item>
                        <el-form-item label="审核反馈" v-if="transData.approveFeedback || transData.homeworkCheck">
                            {{ transData.approveFeedback ? transData.approveFeedback : transData.homeworkCheck }}
                        </el-form-item>
                        <el-form-item label="评分" v-if="transData.approveScore > 0 || transData.score > 0">
                            {{ transData.approveScore ? transData.approveScore : transData.score }}
                        </el-form-item>
                        <div v-for="(ite, index) in planList" :key="index">
                            <el-form-item v-if="ite.type == 1 && ite.value.length > 0" label="文字信息">
                                <div v-for="(itm,i) in ite.value" :key="i">{{ itm.contentName }}</div>
                            </el-form-item>
                            <el-form-item v-if="ite.type == 4 && ite.value.length > 0" label="网盘地址">
                                <div v-for="(itm,i) in ite.value" :key="i">{{ itm.contentName }}</div>
                            </el-form-item>
                            <el-form-item v-if="ite.type == 3 && ite.value.length > 0" label="相关附件">
                                <el-button type="primary" size="small" @click="downAll(data)" style="margin-bottom: 10px">批量下载</el-button>
                                <div class="viewItem" v-for="(itm,i) in ite.value" :key="i">
                                    <div>{{ itm.contentName }}</div>
                                    <em class="el-icon-view viewItemIcon" v-if="itm.contentType == 2" @click="previewImg(itm.content)"></em>
                                    <em class="el-icon-view viewItemIcon" v-if="itm.contentType != 6 && itm.contentType != 2" @click="seeView(itm.content)"></em>
                                    <em class="el-icon-download viewItemIcon"
                                        @click="downloadFile(itm.content, itm.contentType)"></em>
                                </div>
                            </el-form-item>
                        </div>
                    </template>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {
            showDetails: false,
            transData: null,
            planList: [],
            imgList: [],
        }
    },
    props: {
        data: {
            type: Object,
        },
        courseId: {
            type: Number | String,
        },
        businessType: {
            type: Number | String,
        },
    },
    filters: {
        //过滤器一：（使用时没有参数，即{{msg|filterA}}）
        filterA(value) {
            if (typeof value == 'string') return value;
            var date = new Date(Number(value));
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            var h = date.getHours();
            h = h < 10 ? "0" + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? "0" + minute : minute;
            second = second < 10 ? "0" + second : second;
            return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
        }
    },
    mounted() {
        this.transDataFun();
    },
    methods: {
        transDataFun() {
            console.log('hahahah')
            this.transData = this.data.approveInfoResult;
            if (this.data.approveContentList) {
                this.data.approveContentList.map((item) => {
                    if (item.contentType == 2) {
                        this.imgList.push(item.content)
                    }
                })
                let arr2 = this.data.approveContentList.filter((item) => {
                    return item.contentType == 1
                })
                this.planList.push({ type: 1, value: arr2 })
                let arr3 = this.data.approveContentList.filter((item) => {
                    return item.contentType == 4
                })
                this.planList.push({ type: 4, value: arr3 })
                let arr1 = this.data.approveContentList.filter((item) => {
                    return item.contentType != 1 && item.contentType != 4
                })
                this.planList.push({ type: 3, value: arr1 })
            }
            console.log(this.planList)
        },
        showFun() {
            this.showDetails = !this.showDetails
        },
        seeView(url) {
            window.open(url, '_blank')
        },
        checkFile(fileValue) {
            let index = fileValue.lastIndexOf("."); //（考虑严谨用lastIndexOf(".")得到）得到"."在第几位
            let fileValueSuffix = fileValue.substring(index); //截断"."之前的，得到后缀
            if (/(.*)\.(mp4|avi|wmv|MP4|AVI|WMV|mov|MOV)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合视频格式
                return 3;
            } else if (/(.*)\.(png|jpg|jpeg)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合图片格式
                return 2;
            } else if (/(.*)\.(pdf|PDF)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合OFFICE格式
                return 5;
            } else if (/(.*)\.(mp3|MP3|wav|m4a)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合OFFICE格式
                return 7;
            } else if (/(.*)\.(xls|PPT|PPTX|ppt|pptx|XLS|xlsx|XLSX|doc|DOC|docx|DOCX|zip|rar)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合OFFICE格式
                return 6;
            }
            return 6;
        },
        downloadFile(url, name) {
            window.open(`${window.SITE_CONFIG['apiURL']}/course/downloadAttachment?fileUrl=` + encodeURIComponent(decodeURIComponent(url)), '_blank');
        },
        // 批量下载
        downAll(data) {
            console.log(this.allData);
            this.$request.post(`/course/homeworkDownload/addApproveInfoDownload?businessId=${this.courseId}&approveInfoId=${data.approveInfoId ? data.approveInfoId : ''}&businessType=${this.businessType}`, {}).then((res) => {
                console.log(res)
                if (res) {
                    this.$emit('down',res);
                    // this.homeworkDownIDS(res);
                }
            })
        },
        // previewImg(url) {
        //     this.$hevueImgPreview(
        //         {
        //             url,
        //             clickMaskCLose: true
        //         })
        // },
        previewImg(url) {
            for (let i = 0; i < this.imgList.length; i++) {
                if (url == this.imgList[i]) {
                    this.$hevueImgPreview(
                        {
                            multiple: true, // 开启多图预览模式
                            nowImgIndex: i, // 多图预览，默认展示第二张图片
                            imgList: this.imgList, // 需要预览的多图数组
                            // url,
                            clickMaskCLose: true
                        })
                }
            }
        },
        // homeworkDownIDS(data) {
        //     console.log(data);
        //     this.$request
        //         .post(
        //             `/course/homeworkDownload/checkHomeworkDownloadIsOK?homeworkDownloadId=${data}`,
        //             {}
        //         )
        //         .then((res) => {
        //             if (res.downloadUrl == null) {
        //                 this.homeworkDownIDS(res.homeworkDownloadId);
        //             } else {
        //                 window.open(res.downloadUrl);
        //             }
        //         });
        // },
    }
}
</script>

<style scoped>
.statusBox1 {
    width: 6px;
    height: 6px;
    border-radius: 6px;
    position: relative;
    display: inline-block;
}
.statusSuccess {
    background: #67c23a;
    margin-right: 4px;
}

.statusFail {
    background: #f56c6c;margin-right: 4px;
}
.tableLine {
    border-top: 1px solid #DFE0E2;
}

.contentLine {
    display: flex;
    flex-direction: row;
    height: 50px;
}

.oper {
    color: #1C69D4;
    cursor: pointer;
}

.tableBoxTitle {
    text-align: left;
    padding: 12px;
    flex: 1;
    font-size: 14px;
    display: flex;
    align-content: center;
    align-items: center;
}
.tableBoxTitleFirst, .tableBoxTitleLast {
    text-align: left;
    display: flex;
    align-content: center;
    align-items: center;
    width: 120px;
    padding: 12px;
}

.tableBoxTitleLast {
    width: 80px;
}

.contentDetails {
    padding: 0 20px 10px 20px;
}

.detailsBox {
    background: rgba(223, 224, 226, 0.2);
    padding-top: 8px;
    margin-top: 10px;
}

.detailsBox::before {
    position: relative;
    top: -32px;
    left: 96%;
    content: '';
    border-bottom: 8px solid rgba(223, 224, 226, 0.2);
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
}

.viewItem {
    display: flex;
}

.viewItemIcon {
    line-height: 30px;
    margin-left: 6px;
    cursor: pointer;
    color: #1C69D4;
}

.pageTitle {
    font-weight: bold;
    font-size: 16px;
    color: #252628;
    height: 40px;
    line-height: 30px;
    text-indent: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    margin-bottom: 12px;
}
</style>
